import "./App.css";
import LoadVideos from "./LoadVideos";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h4>Video Recommendation</h4>
      </header>
      <LoadVideos/>
    </div>
  );
}

export default App;
